import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    preserveWhitespaces: true // buttonタグ同士のスペースを維持する。これが無いと、横並びのbuttonタグの隙間が無くなってしまう。
  })
  .catch(err => console.log(err));
